export const SET_WELCOME_ALERTS_SPEED_LOADING = 'SET_WELCOME_ALERTS_SPEED_LOADING'
export const GET_WELCOME_ALERTS_SPEED_DATA = 'GET_WELCOME_ALERTS_SPEED_DATA'
export const GET_WELCOME_ALERTS_SPEED_CONTACTS_DATA = 'GET_WELCOME_ALERTS_SPEED_CONTACTS_DATA'
export const CLEAR_WELCOME_ALERTS_SPEED_DATA = 'CLEAR_WELCOME_ALERTS_SPEED_DATA'
